<script>
export default {
  props: {
    inputValue: Number,
    inputTitle: String,
    fieldName: String,
    inputNotation: String,
    method: {type: Function},
    selectedUnit: String,
    inputNotationOptions: {
      type: Array,
      required: true
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      open: false
    };
  },
  mounted() {
    this.$emit('input', this.selectedUnit);
  }
};
</script>

<template>
  <div class="input-row">
    <div class="row-title">{{ inputTitle }}</div>
    <div class="input-wrapper">
      <input
          type="number"
          class="compare-input"
          :value="inputValue"
          @input="$emit('updateFormData', fieldName, $event.target.value)"
      />
      <div class="input-notation">
        <div class="custom-select" :tabindex="tabindex" @blur="open = false">
          <div class="selected" :class="{ open: open }" @click="open = !open">
            {{ selectedUnit }}
          </div>
          <div class="items" :class="{ selectHide: !open }">
            <div
                v-for="(option, i) of inputNotationOptions"
                :key="i"
                @click="
                  open = false;
                  $emit('input', option);
                "
            >
              {{ option }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.input-row {
  width: 80%;
  margin: 0 auto 10px;
}

.input-wrapper {
  background-color: white;
  border-radius: 5px;
  border: 2px solid var(--text-color);
  margin: 5px 0 0;
  display: flex;
  justify-content: space-between;
}

.row-title {
  font-size: 12px;
}

.compare-input {
  border: 0;
  padding: 5px 5px 5px 10px;
  border-radius: 5px 0 0 5px;
  width: 340px;
}

.input-notation {
  background-color: #f5f5f5;
  width: 70px;
  text-align: center;
  padding: 5px 0;
  word-break: break-word;
  font-size: 14px;
  line-height: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 5px 5px 0;
}

.custom-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  padding: 3px 0;
}

.custom-select .selected {
  cursor: pointer;
  user-select: none;
  text-align: center;
}

.custom-select .selected.open {
  border: 1px solid var(--text-color);
  border-radius: 3px 3px 0 0;
  background-color: white;
}

.custom-select .selected:after {
  position: absolute;
  content: "";
  top: 18px;
  right: 23px;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: var(--text-color) transparent transparent transparent;
}

.custom-select .items {
  border-radius: 0 0 3px 3px;
  overflow: hidden;
  border-right: 1px solid var(--text-color);
  border-left: 1px solid var(--text-color);
  border-bottom: 1px solid var(--text-color);
  position: absolute;
  background-color: white;;
  left: 0;
  right: 0;
  z-index: 1;
}

.custom-select .items div {
  cursor: pointer;
  user-select: none;
  padding: 5px 3px;
}

.custom-select .items div:hover {
  background-color: #f6f6f6;
}

.selectHide {
  display: none;
}
</style>
